import React, { useEffect } from "react";

import Service from "../core/Service";
import useService from '../core/ServiceRegistry';
import ServiceProvider from "../core/ServiceProvider";
import { injectedService } from "@base/core";

function updateHead({ title, description, canonical }) {
  if (title) document.title = title;

  if (description) {
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description);
  }

  if (canonical !== undefined) {
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
  }
}

export class PageDescriberService extends Service {
    pages = null;
    withCanonical = false;

    initState(dependencies, refs) {
        super.initState(dependencies, refs);
        this._applyCurrent();

        this._wrapHistoryMethod("pushState");
        this._wrapHistoryMethod("replaceState");

        window.addEventListener("popstate", this._applyCurrent);
    }

    destroy() {
        window.removeEventListener("popstate", this._applyCurrent);
    }

    _wrapHistoryMethod(method) {
        const original = history[method];
        const self = this;
        history[method] = function () {
            const result = original.apply(this, arguments);
            self._applyCurrent();
            return result;
        };
    }

    _applyCurrent = () => {
        const url = window.location.pathname + window.location.search;
        const page = this._matchPage(url);
        if (page) {
          const head = { ...page };
          if (this.withCanonical) {
            head.canonical = window.location.origin + this._getCanonicalPath();
          }
          updateHead(head);
        }
    };

    _matchPage(url) {
        return this.pages[url] ?? this.pages.default;
    }

    _getCanonicalPath() {
        const pathname = window.location.pathname;
        const knownPaths = [...new Set(
            Object.keys(this.pages)
                .filter(k => k !== 'default')
                .map(k => k.split('?')[0])
        )].sort((a, b) => b.length - a.length);

        for (const path of knownPaths) {
            if (pathname === path || pathname.startsWith(path)) {
                return path;
            }
        }
        return pathname;
    }
}

export default injectedService(
    {
        name: "PageDescriberServiceProvider",
        services: [],
        components: [],
    },
    function PageDescriberServiceProvider({ id, children, pages, withCanonical = false }) {

        return (
            <ServiceProvider serviceId={id} serviceClass={PageDescriberService} dependencies={{ pages, withCanonical }}>
                {children}
            </ServiceProvider>
        );
    }
);